import React from "react";
import "./ConfirmationButton.scss";
import * as headerActions from "../../../actions/header";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { useTranslation } from "react-i18next";

const ConfirmationButton = ({ submitOrderHandler, requisites, ordered }) => {
  const { t } = useTranslation();
  const phone = requisites && requisites.phone ? requisites.phone : "+370 673 62 767";

  return (
    <div className="conf-cart">
      <p>
        {t("confirmation.text")} {" "}
        <a href={`tel:${phone.replace(/\s/g, "")}`}>{phone}</a>
      </p>

      <button type="button" onClick={submitOrderHandler}>
        {t("confirmation.submit")}
      </button>
    </div>
  );
};

const mapStateToProps = (state) => ({
  requisites: state.header.requisites,
});

const mapDispatchToProps = (dispatch) => ({
  ...bindActionCreators(headerActions, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(ConfirmationButton);